import React from "react";
import { Link } from "react-router-dom";
import { Container, Typography, Button, Box, Paper } from "@mui/material";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useSelector } from "react-redux";
import { Marquee, Platforms, Trust } from "../components/Sections";

const Oops = () => {
  const state = useSelector((state) => state);

  return (
    <>
      <Sidebar />
      <div
        className="anigrad"
        style={{
          paddingBottom: "50px",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            mt: 15,
            mb: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "45vh",
            border: "1px solid black",
            borderRadius: "15px",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 100, color: "white", mb: 2 }} />

          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: "bold", color: "white" }}
          >
            Oops! Page Not Found
          </Typography>

          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{ mb: 4, color: "white" }}
          >
            The page you are looking for doesn't exist or has been moved.
          </Typography>

          <Box sx={{ mb: 4, color: "white" }}>
            <Typography variant="body1" paragraph>
              We suggest checking the URL for any typos or returning to our
              homepage.
            </Typography>
          </Box>

          <Button
            component={Link}
            to="/"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: "#1868DD",
              "&:hover": {
                backgroundColor: "#0d47a1",
              },
              px: 4,
              py: 1.5,
              borderRadius: 8,
            }}
          >
            Back to Homepage
          </Button>
        </Container>
      </div>
      <Marquee />
      <Footer />
    </>
  );
};

export default Oops;
